import Recipient from "../models/Recipient";
export const RecipientMixin = {
  data() {
    return {
      recipient: this.initialize()
    }
  },
  methods: {
    initialize() {
      return new Recipient({
        name: undefined,
        description: undefined,
        phone: undefined,
        address: undefined,
        bank_id: undefined,
        payment_method_id: undefined,
        currency_acronym: undefined,
        notes: undefined,
        number: undefined,
        user: undefined,
        bank_required: false
      })
    }
  }
}
